import React, { useState } from "react";
import "./survey_form_1.css";
import OfficeCard from "./../officemap/visit_office_map";

import { BASE_URL, ADD_JOB_APPLICATION } from "../../constants/Apis";


const ContactSection = ({ path, office }) => {
  return (
    <section className="contact-section">
      <div className="contact-container">
        {/* Left: Survey Form */}
        <div className="contact-item">
          <SurveyForm path={path} />
        </div>

        {/* Right: Office Card */}
        <div className="contact-item">
          <OfficeCard />
        </div>
      </div>
    </section>
  );
};

function SurveyForm({ path }) {
  const [formData, setFormData] = useState({
    fullname: "",
    phone: "",
    email: "",
    subject: "I'm looking for a job",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name: formData.fullname,
      email: formData.email,
      contact: formData.phone,
      interested_position: "", // not applicable for contact form
      subjects: formData.subject,
      details: formData.message,
    };

    try {
      const res = await fetch(`${BASE_URL}${ADD_JOB_APPLICATION}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data.success) {
        alert("✅ Message sent successfully!");
        setFormData({
          fullname: "",
          phone: "",
          email: "",
          subject: "I'm looking for a job",
          message: "",
        });
      } else {
        alert("❌ Failed to send message.");
      }
    } catch (err) {
      console.error(err);
      alert("⚠️ Error submitting the form.");
    }
  };

  return (
    <section className="survey-section">
      <div className="survey-card">
        <h2 className="form-title">Send us a message</h2>
        <p className="form-description">
          Fill out the form below and we'll get back to you within 24 hours.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="fullname">Full Name</label>
              <input
                type="text"
                id="fullname"
                value={formData.fullname}
                onChange={handleChange}
                placeholder="Enter your full name"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                id="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone number"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <select id="subject" value={formData.subject} onChange={handleChange}>
              <option>I'm looking for a job</option>
              <option>I need to hire talent</option>
              <option>Partnership enquiry</option>
              <option>General enquiry</option>
              <option>Support</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              rows="3"
              value={formData.message}
              onChange={handleChange}
              placeholder="Type your message here..."
              required
            ></textarea>
          </div>

          <button type="submit" className="submit-btn">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
}

export default ContactSection;
